import { z } from 'zod';

export const WAREHOUSE_STATUSES = ['active', 'paused', 'disabled'] as const;
export type WarehouseStatus = (typeof WAREHOUSE_STATUSES)[number];

export const WarehouseCreateSchema = z.object({
  clientId: z.string().uuid('Выберите клиента'),
  name: z.string().trim().min(1, 'Введите название').max(128),
  description: z.string().trim().max(1024).optional(),
  status: z.enum(WAREHOUSE_STATUSES).optional(),
});

export const WarehouseUpdateSchema = z.object({
  name: z.string().trim().min(1).max(128).optional(),
  description: z.string().trim().max(1024).optional(),
  status: z.enum(WAREHOUSE_STATUSES).optional(),
});

export type WarehouseCreateInput = z.infer<typeof WarehouseCreateSchema>;
export type WarehouseUpdateInput = z.infer<typeof WarehouseUpdateSchema>;
